import { FactsAndFiguresBlockItem } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.state'
import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const FactsAndFiguresBlock: BlocksView['FactsAndFiguresBlock'] = (props) => {
  const { id, title, items } = props
  if (items?.length == 0) return <></>

  const { inView, ref } = useInView({ threshold: 0.1 })
  const subHeading = title ? 'h3' : 'h2'
  return (
    <section id={id} ref={ref} className={cn('block block--facts ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        <div className="block__content--full">
          <ListLayout items={items} subHeading={subHeading} listClassName="block__list" />
        </div>

        <BlockActions {...props} datalayerCategory="facts_features_block" />
      </div>
    </section>
  )
}

const ListLayout = (props: { items: FactsAndFiguresBlockItem[]; subHeading: 'h2' | 'h3'; listClassName?: string }) => {
  return (
    <ul className={cn('facts ls-spacing gridsys--grid', props.listClassName)}>
      {props.items.map((item, index) => {
        return <ItemLayout key={index} {...item} subHeading={props.subHeading} />
      })}
    </ul>
  )
}

const ItemLayout = (p: { subHeading: 'h2' | 'h3' } & FactsAndFiguresBlockItem) => {
  const { value, description, subHeading } = p
  const SubHeading = subHeading

  return (
    <li className="facts__item">
      <SubHeading className="facts__title title--2xl">{value}</SubHeading>
      <svg className='facts__seperator' width="27" height="27" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="blue100" d="M15.6198 11.4974C14.7867 14.904 8.18289 14.865 4.80016 14.0246C1.41744 13.1842 -0.649468 9.7406 0.185031 6.33402C1.01953 2.92698 4.43766 0.846901 7.82039 1.68588C11.2036 2.52626 16.4543 8.08893 15.6198 11.4974Z" fill="#E87722"/></svg>
      <p className="facts__description">{description}</p>
    </li>
  )
}
